module.exports = __webpack_public_path__ + "images/mstile-310x310-7049102d29d7f4d4bbdb0cb055f1b490.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/mstile-310x310.png
// module id = ./src/images/favicons/mstile-310x310.png
// module chunks = 1